enum CreativeFileStatus {
  PROCESSING = 'processing',
  UPLOADED = 'uploaded',
  FAILED = 'failed',
  STORED_IN_BEESWAX = 'stored_in_beeswax',
}

export default CreativeFileStatus;
